import { render, staticRenderFns } from "./diveCommentAdd.vue?vue&type=template&id=cddf844e&scoped=true&"
import script from "./diveCommentAdd.vue?vue&type=script&lang=js&"
export * from "./diveCommentAdd.vue?vue&type=script&lang=js&"
import style0 from "./diveCommentAdd.vue?vue&type=style&index=0&id=cddf844e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddf844e",
  null
  
)

export default component.exports